import {CreateAdminNews} from './create-admin-news';

export default CreateAdminNews;
